export interface TagCountResponse {
  [tagName: string]: number;
}

export type TagSortByOptions = 'name' | 'assetCount';

const queriedNames = (tags: TagCountResponse, queryString: string): string[] => (
  Object.keys(tags).filter((tagName) => (
    tagName.toLowerCase().includes(queryString.toLowerCase())
  ))
);

const namesSortedByName = (tags: TagCountResponse, queryString: string): string[] => {
  const namesToSort = queryString ? queriedNames(tags, queryString) : Object.keys(tags);
  return namesToSort.sort((a, b) => ((a.toLowerCase() < b.toLowerCase()) ? -1 : 1));
};

const namesSortedByCount = (tags: TagCountResponse, queryString: string): string[] => {
  const namesToSort = queryString ? queriedNames(tags, queryString) : Object.keys(tags);
  return namesToSort.sort((a, b) => ((tags[a] < tags[b]) ? 1 : -1));
};

export const sortedNames = (tags: TagCountResponse, queryString: string, sortBy: TagSortByOptions): string[] => (
  sortBy === 'assetCount' ? namesSortedByCount(tags, queryString) : namesSortedByName(tags, queryString)
);

export const updateVisibleTags = (
  tags: TagCountResponse,
  setTags: SetStateDispatch<TagCountResponse>,
  oldName: string,
  newName: string | null
): void => {
  let updatedTags: TagCountResponse;
  if (newName) {
    updatedTags = Object.assign(tags, { [newName]: tags[oldName] });
  } else {
    updatedTags = Object.assign({}, tags);
  }
  delete updatedTags[oldName];
  setTags(updatedTags);
};